import * as React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';

const StySelectChevron = styled(KeyboardArrowDownIcon, {
    name: 'StySelectChevron',
})(({ theme }) => ({
    padding: '8px',
    width: '36px',
    height: '36px',
    stroke: 'primary',
    '& path': {
        fill: theme.palette.primary.main,
    },
    '&:hover': {
        path: {
            fill: '#999999',
        },
    },
}));

const SelectChevron = (): React.ReactElement => <StySelectChevron />;

export default SelectChevron;
